import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
        <path
            d="M2.99999 12.0001L2.26839 11.835L2.23111 12.0001L2.2684 12.1653L2.99999 12.0001ZM21 11.9999L21.7316 12.165L21.7689 11.9999L21.7316 11.8347L21 11.9999ZM3.73158 12.1653C4.55603 8.51292 7.9315 5.75 12 5.75V4.25C7.24831 4.25 3.25116 7.48129 2.26839 11.835L3.73158 12.1653ZM12 5.75C16.0685 5.75 19.4439 8.51281 20.2684 12.165L21.7316 11.8347C20.7487 7.48116 16.7516 4.25 12 4.25V5.75ZM20.2684 11.8347C19.444 15.4871 16.0685 18.25 12 18.25V19.75C16.7517 19.75 20.7488 16.5187 21.7316 12.165L20.2684 11.8347ZM12 18.25C7.93153 18.25 4.55612 15.4872 3.73157 11.835L2.2684 12.1653C3.25127 16.5189 7.24835 19.75 12 19.75V18.25Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
